import { middlewareContext } from '@/router'

export default function checkDeletionAccount ({ next, store, nextMiddleware }: middlewareContext): void | Promise<unknown> {
  if (store.getters['profile/getDeletionRequested']) {
    return next({ name: 'RestoreAccount' })
  }
  return nextMiddleware()
}
